import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * Aktualisiert alle .premium-price-Blöcke (z. B. Premium Preis auf product.schmuck) aus dem Section-HTML.
 * Wird bei variant:update aufgerufen, damit der Preis auch ohne <product-price> aktualisiert wird.
 * @param {VariantUpdateEvent} event
 */
function updatePremiumPricesOnVariantChange(event) {
  const html = event.detail?.data?.html;
  if (!html) return;

  const eventProductId = event.detail?.data?.productId;
  const source = event.target instanceof HTMLElement ? event.target : null;
  const section = source?.closest?.('.shopify-section, [id^="shopify-section"]');
  if (!section) return;

  section.querySelectorAll('.premium-price[data-block-id][data-product-id]').forEach((currentEl) => {
    const productId = currentEl.getAttribute('data-product-id');
    if (eventProductId && productId !== eventProductId) return;

    const blockId = currentEl.getAttribute('data-block-id');
    const newEl = html.querySelector(`.premium-price[data-block-id="${blockId}"]`);
    if (newEl && newEl.innerHTML !== currentEl.innerHTML) {
      currentEl.innerHTML = newEl.innerHTML;
    }
  });
}

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price and volume pricing note.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const html = event.detail.data?.html;
    if (!html) return;

    // product-price (Standard-Preisblock)
    const newProductPrice = html.querySelector(`product-price[data-block-id="${this.dataset.blockId}"]`);
    if (newProductPrice) {
      const newPrice = newProductPrice.querySelector('[ref="priceContainer"]');
      const currentPrice = this.querySelector('[ref="priceContainer"]');
      if (newPrice && currentPrice) currentPrice.replaceWith(newPrice);

      const currentNote = this.querySelector('.volume-pricing-note');
      const newNote = newProductPrice.querySelector('.volume-pricing-note');
      if (!newNote) {
        currentNote?.remove();
      } else if (!currentNote) {
        this.querySelector('[ref="priceContainer"]')?.insertAdjacentElement('afterend', /** @type {Element} */ (newNote.cloneNode(true)));
      } else {
        currentNote.replaceWith(newNote);
      }
      return;
    }
  };
}

// Globaler Listener: Aktualisiert .premium-price auch auf Templates ohne <product-price> (z. B. product.schmuck)
document.addEventListener(ThemeEvents.variantUpdate, updatePremiumPricesOnVariantChange);

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
